// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"106":"2e80e89a","470":"2e80e89a"}[chunkId] + ".chunk.css";
};